/** The backend enforces the same account restriction before reading Sage. */
export const METALNORD_USERS = ["riccardo"];

export function canAccessMetalnord(user) {
    return user?.is_active !== false && METALNORD_USERS.includes(user?.username);
}
